<template>
  <van-dialog v-model="show">
    <img class="qrCode" src="../../../static/img/qrCode.jpg" />
    <div class="txt">
        您的账号未开通会员功能或账号已过期。扫码添加文本基因计划客服，欢迎咨询、订阅开通文本基因会员功能。
    </div>
  </van-dialog>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      show: true,
      content: {
        type: String,
        default: "",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
.qrCode{
width: 3rem;
margin-left: calc(50% - 1.5rem);
}
.txt{
    width: 100%;
    padding: 0 .3rem .3rem;
    box-sizing: border-box;
    font-size: 0.18rem;
    font-weight: normal;
    font-family: "STSongti-SC-Bold";
}
</style>


// WEBPACK FOOTER //
// src/components/promptBox/index.vue